<template>
    <div>
        <b-row class="content-header">
            <b-col class="content-header-left mb-2" cols="12" md="9">
                <b-row class="breadcrumbs-top">
                    <b-col cols="12">
                        <h2>Privacy Policy</h2>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-card>
            <h5>Privacy Policy</h5>
            <p>
                We respect your privacy and are committed to protecting your
                personal data. This Privacy Policy explains what information we
                collect, how we use it, and your rights regarding your data. By
                using our Service, you agree to the terms of this Privacy
                Policy.
            </p>

            <h5>1. Changes to This Policy</h5>
            <p>
                This Privacy Policy may be updated or modified at any time,
                without prior notice. Continued use of the Service constitutes
                your acceptance of the revised Privacy Policy.
            </p>

            <h5>2. Cookies Usage</h5>
            <p>
                We use cookies to keep you logged in while using the Service.
                When you sign out, these cookies are deleted. We do not use
                cookies for tracking, advertising, or any other purposes beyond
                authentication.
            </p>

            <h5>3. Data We Collect</h5>
            <ul>
                <li>
                    <strong>IP Address & Geolocation:</strong> We store IP
                    addresses and their approximate geolocation for internal use
                    only (e.g., abuse prevention, account protection, bandwidth
                    performance monitoring).
                </li>
                <li>
                    <strong>Email & Password:</strong> When you sign up, your
                    email is stored on our servers. Passwords are encrypted
                    using strong algorithms and cannot be decrypted, even by us.
                </li>
                <li>
                    <strong>Request Logs:</strong> Our servers log IP addresses,
                    request dates, and technical error data for debugging,
                    abuse prevention, and support purposes.
                </li>
                <li>
                    <strong>Browser & Operating System:</strong> We record
                    browser type and operating system for internal usage only
                    (e.g., optimizing service performance).
                </li>
            </ul>

            <h5>4. Payment Information</h5>
            <p>
                All payments are processed securely through trusted third-party
                payment providers. We do not store your payment card details on
                our servers. All transactions are encrypted and processed over
                HTTPS.
            </p>

            <h5>5. Data Sharing</h5>
            <p>
                We do not sell or rent your personal data. We may share limited
                data only with trusted service providers when necessary to
                operate the Service, process payments, prevent abuse, provide
                support, or comply with legal obligations. If you wish to delete
                your account and related data, you may contact us at any time.
            </p>

            <h5>6. Data Security</h5>
            <p>
                We implement reasonable technical and organizational measures to
                protect your information from unauthorized access, loss, misuse,
                or disclosure. However, no method of transmission over the
                Internet is 100% secure, and we cannot guarantee absolute
                security.
            </p>

            <h5>7. Contact</h5>
            <p>
                If you have any questions or requests regarding this Privacy
                Policy or your personal data, please contact us.
            </p>
        </b-card>
    </div>
</template>

<script>
import { BRow, BCol, BCard } from "bootstrap-vue";
export default {
    components: {
        BRow,
        BCol,
        BCard,
    },
};
</script>

<style></style>
